import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { platformService } from '@/services/platformService'

const STATUSES = ['NEW', 'CONTACTED', 'QUALIFIED', 'CONVERTED', 'LOST']
const STATUS_STYLE: Record<string, string> = {
    NEW: 'bg-slate-700 text-slate-300',
    CONTACTED: 'bg-sky-900 text-sky-300',
    QUALIFIED: 'bg-indigo-900 text-indigo-300',
    CONVERTED: 'bg-emerald-900 text-emerald-300',
    LOST: 'bg-rose-900 text-rose-300',
}
const EMPTY = { name: '', company: '', email: '', phone: '', source: '' }

export default function LeadsPage() {
    const [leads, setLeads] = useState<any[]>([])
    const [loading, setLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [form, setForm] = useState(EMPTY)

    const reload = () => {
        setLoading(true)
        platformService.crmLeads().then(setLeads).catch(() => toast.error('No se pudieron cargar los leads')).finally(() => setLoading(false))
    }
    useEffect(reload, [])

    const create = async (e: React.FormEvent) => {
        e.preventDefault()
        try { await platformService.crmCreateLead(form); toast.success('Lead creado'); setShowModal(false); setForm(EMPTY); reload() }
        catch { toast.error('No se pudo crear') }
    }
    const changeStatus = async (l: any, status: string) => {
        try { await platformService.crmUpdateLead(l.id, { status }); reload() }
        catch { toast.error('No se pudo actualizar') }
    }
    const remove = async (l: any) => {
        if (!window.confirm(`¿Eliminar lead "${l.name}"?`)) return
        try { await platformService.crmDeleteLead(l.id); reload() } catch { toast.error('No se pudo eliminar') }
    }

    const byStatus = (s: string) => leads.filter((l) => l.status === s).length

    return (
        <div>
            <div className="mb-6 flex items-center justify-between">
                <h1 className="text-2xl font-semibold">Leads</h1>
                <button onClick={() => setShowModal(true)} className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-500">+ Nuevo lead</button>
            </div>

            <div className="mb-6 flex flex-wrap gap-3 text-sm">
                {STATUSES.map((s) => (
                    <span key={s} className={`rounded-full px-3 py-1 ${STATUS_STYLE[s]}`}>{s}: {byStatus(s)}</span>
                ))}
            </div>

            <div className="overflow-hidden rounded-xl border border-slate-800">
                <table className="w-full text-left text-sm">
                    <thead className="bg-slate-800/70 text-slate-300"><tr>
                        <th className="px-4 py-3">Nombre</th><th className="px-4 py-3">Empresa</th><th className="px-4 py-3">Contacto</th>
                        <th className="px-4 py-3">Origen</th><th className="px-4 py-3">Estado</th><th className="px-4 py-3"></th>
                    </tr></thead>
                    <tbody className="divide-y divide-slate-800">
                        {loading && leads.length === 0 ? (
                            <tr><td colSpan={6} className="px-4 py-6 text-center text-slate-400">Cargando…</td></tr>
                        ) : leads.length === 0 ? (
                            <tr><td colSpan={6} className="px-4 py-6 text-center text-slate-400">Sin leads</td></tr>
                        ) : leads.map((l) => (
                            <tr key={l.id} className="text-slate-200">
                                <td className="px-4 py-2">{l.name}</td>
                                <td className="px-4 py-2 text-slate-400">{l.company || '—'}</td>
                                <td className="px-4 py-2 text-xs text-slate-400">{l.email || l.phone || '—'}</td>
                                <td className="px-4 py-2 text-slate-400">{l.source || '—'}</td>
                                <td className="px-4 py-2">
                                    <select value={l.status} onChange={(e) => changeStatus(l, e.target.value)}
                                        className={`rounded-md border-0 px-2 py-1 text-xs ${STATUS_STYLE[l.status] || ''}`}>
                                        {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                                    </select>
                                </td>
                                <td className="px-4 py-2 text-right">
                                    <button onClick={() => remove(l)} className="text-xs text-rose-400 hover:underline">eliminar</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {showModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
                    <form onSubmit={create} className="w-full max-w-md space-y-3 rounded-xl border border-slate-700 bg-slate-800 p-6">
                        <h2 className="text-lg font-semibold text-slate-100">Nuevo lead</h2>
                        {([['name', 'Nombre', true], ['company', 'Empresa', false], ['email', 'Email', false], ['phone', 'Teléfono', false], ['source', 'Origen (web, referido…)', false]] as const).map(([k, label, req]) => (
                            <input key={k} value={(form as any)[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} placeholder={label} required={req}
                                className="w-full rounded-md border border-slate-600 bg-slate-900 px-3 py-2 text-sm text-slate-100 outline-none focus:border-indigo-500" />
                        ))}
                        <div className="flex justify-end gap-2 pt-2">
                            <button type="button" onClick={() => setShowModal(false)} className="rounded-md border border-slate-600 px-4 py-2 text-sm text-slate-300 hover:bg-slate-700">Cancelar</button>
                            <button type="submit" className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-500">Crear</button>
                        </div>
                    </form>
                </div>
            )}
        </div>
    )
}
